export enum WatchState {
  JustWatched,
  Watched,
  NotWatching,
}
